import React, { useCallback } from "react";
import { List, ListItem, SxProps, Typography } from "@mui/material";
import { AthletesByBulkAssignGoalTemplateJobForStatusModalFragment } from "apps/web/src/types";
import { JobStatusModalAthleteListItem } from "./JobStatusModalAthleteListItem";
import { UseInfiniteCursorConnectionScrollResults } from "apps/web/src/components/universal/InfiniteScroll/useInfiniteCursorConnectionScroll";
import InfiniteScrollContainer from "apps/web/src/components/universal/InfiniteScroll/InfiniteScrollContainer";
import { useTranslation } from "react-i18next";

const listItemStyle = { width: `calc(100% - ${1})` };

interface JobStatusModalAthleteInfiniteScrollProps {
  sx?: SxProps;
  searchResults: UseInfiniteCursorConnectionScrollResults<
    "athletesByBulkAssignGoalTemplateJobCursorConnection",
    AthletesByBulkAssignGoalTemplateJobForStatusModalFragment
  >;
  onClickItem: (athlete: AthletesByBulkAssignGoalTemplateJobForStatusModalFragment) => void;
}

export const JobStatusModalAthleteInfiniteScroll = ({
  onClickItem,
  sx,
  searchResults,
}: JobStatusModalAthleteInfiniteScrollProps) => {
  const { t } = useTranslation();
  const renderItem = useCallback(
    (
      athlete: AthletesByBulkAssignGoalTemplateJobForStatusModalFragment,
      forwardRef?: React.MutableRefObject<HTMLDivElement | null>
    ) => {
      return (
        <div ref={forwardRef} key={athlete.id}>
          <JobStatusModalAthleteListItem
            athlete={athlete}
            onClick={onClickItem}
          />
        </div>
      );
    },
    [onClickItem]
  );

  return (
    <List disablePadding sx={sx}>
      <InfiniteScrollContainer
        noItemsComponent={
          <ListItem sx={listItemStyle}>
            <Typography>{t("goalConfigurationTemplates.bulkAssign.status.modal.noAthletesFound")}</Typography>
          </ListItem>
        }
        renderItem={renderItem}
        infiniteScrollResults={searchResults}
        loadingOffset={10}
      />
    </List>
  );
};
